import { type IAsyncExpression } from './repository/async/IAsyncExpression.ts';
import { type IComputedDateExpression } from './repository/computed-date/IComputedDateExpression.ts';
import { type IConditionExpression } from './repository/condition/IConditionExpression.ts';
import { type IConditionGroupExpression } from './repository/condition-group/IConditionGroupExpression.ts';
import { type IFunctionExpression } from './repository/function/IFunctionExpression.ts';
import { type IReferenceExpression } from './repository/reference/IReferenceExpression.ts';
import { type ISubconditionsGroupExpression } from './repository/subconditions-group/ISubconditionsGroupExpression.ts';
import { type ISwitchExpression } from './repository/switch-expression/ISwitchExpression.ts';
import { type IValueExpression } from './repository/value/IValueExpression.ts';

export enum ExpressionType {
  Value = 'value',
  Reference = 'reference',
  Function = 'function',
  Condition = 'condition',
  ConditionGroup = 'conditionGroup',
  Switch = 'switch',
  SubconditionsGroup = 'subconditionsGroup',
  Async = 'async',
  ComputedDate = 'computedDate',
}

/**
 * Ogni Espressione possibile deve essere censita qui, a prescindere che sia
 * utilizzata come una regola di validazione o come un campo calcolato. Deve
 * avere sempre un `type` univoco e censito.
 *
 * A livello concettuale, ad esempio, una regola di validazione equivale
 * a un booleano che, se true, esprime un messaggio di errore.
 *
 * Il concetto di espressione è limitato al fatto che **restituisca un unico
 * valore**. Tutto ciò che è più complesso di un valore singolo è gestito
 * da ulteriori strutture dati.
 */
export type IExpression =
  | IValueExpression
  | IReferenceExpression
  | IFunctionExpression
  | IConditionExpression
  | IConditionGroupExpression
  | IAsyncExpression
  | ISubconditionsGroupExpression
  | ISwitchExpression
  | IComputedDateExpression;
